import type { KeyboardEvent } from "react";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Field } from "@/widgets/classic-form/form";
import { RecordSubject } from "../../form/types";
import styles from "./RotatedRecords.module.scss";

export const RotatedRecords = () => {
    const { t } = useTranslation();
    const id = useId();

    const handleKeyDown = (
        e: KeyboardEvent<HTMLInputElement>,
        value: RecordSubject,
        callback: (v: RecordSubject) => void,
    ) => {
        if (e.key === "Enter" || e.key === " ") {
            callback(value === RecordSubject.Primary ? RecordSubject.All : RecordSubject.Primary);
            e.preventDefault();
        }
    };

    return (
        <Field name="recordSubject">
            {({ value, onChange }) => (
                <div className={styles.primaryRecordsOnly}>
                    <input
                        id={id}
                        type="checkbox"
                        className="checkbox"
                        checked={value === "primary"}
                        onChange={() =>
                            onChange(value === RecordSubject.Primary ? RecordSubject.All : RecordSubject.Primary)
                        }
                        onKeyDown={(e) => handleKeyDown(e, value, onChange)}
                        title={t("primaryRecordsOnly")}
                    />
                    <label htmlFor={id}>{t("primaryRecordsOnly")}</label>
                </div>
            )}
        </Field>
    );
};
